import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MessageCircle, MapPin, Facebook, MessageSquareText } from "lucide-react";
import { useSite } from "../../context/SiteContext";
import { links } from "../../lib/api";
import { NAV, useNavTo, Logo } from "./Header";

const Footer = () => {
  const { content, openChat, t } = useSite();
  const go = useNavTo();
  const l = links(content);
  return (
    <footer className="bg-[#0f2e2a] text-white/80 pb-24 md:pb-0" data-testid="site-footer">
      <div className="mx-auto grid max-w-[1346px] gap-12 px-6 py-16 lg:w-[86%] lg:px-0 md:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <div className="inline-block rounded-xl bg-white px-4 py-3"><Logo className="h-9" /></div>
          <p className="mt-5 max-w-sm text-[15px] leading-relaxed text-white/65">
            {t("{brand} helps people resell sealed, unexpired testing supplies they no longer need. Free quotes, free shipping and friendly people, nationwide.", { brand: content?.brand })}
          </p>
          <a href={content?.facebook} target="_blank" rel="noreferrer" className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-[#7ce3d2] hover:text-white transition-colors">
            <Facebook size={16} /> {t("Follow us on Facebook")}
          </a>
        </div>
        <div>
          <h4 className="mb-5 text-[15px] font-semibold text-white">{t("Quick Links")}</h4>
          <ul className="space-y-3 text-[15px]">
            <li><button onClick={() => go("/")} className="hover:text-[#7ce3d2] transition-colors">{t("Home")}</button></li>
            {NAV.map((n) => (
              <li key={n.label}><button onClick={() => go(n.to)} className="hover:text-[#7ce3d2] transition-colors">{t(n.label)}</button></li>
            ))}
            <li><Link to="/track" onClick={() => window.scrollTo(0, 0)} className="hover:text-[#7ce3d2] transition-colors" data-testid="footer-track">{t("Track My Payout")}</Link></li>
            <li><Link to="/sell-test-strips" onClick={() => window.scrollTo(0, 0)} className="hover:text-[#7ce3d2] transition-colors">{t("Areas We Serve (50 States)")}</Link></li>
            <li><Link to="/admin" className="hover:text-[#7ce3d2] transition-colors" data-testid="footer-agent-login">{t("Agent Login")}</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="mb-5 text-[15px] font-semibold text-white">{t("Contact")}</h4>
          <ul className="space-y-4 text-[15px]">
            <li><a href={l.tel} className="flex items-center gap-3 hover:text-[#7ce3d2]"><Phone size={16} className="text-[#5fd4c1]" />{t("Call / Text")}: {content?.phone_display}</a></li>
            <li><a href={l.wa} target="_blank" rel="noreferrer" className="flex items-center gap-3 hover:text-[#7ce3d2]"><MessageCircle size={16} className="text-[#5fd4c1]" />WhatsApp: {content?.whatsapp_display}</a></li>
            <li><a href={l.mail} className="flex items-center gap-3 hover:text-[#7ce3d2] break-all"><Mail size={16} className="shrink-0 text-[#5fd4c1]" />{content?.email}</a></li>
            {content?.email2 && <li><a href={l.mail2} className="flex items-center gap-3 hover:text-[#7ce3d2] break-all" data-testid="footer-email2"><Mail size={16} className="shrink-0 text-[#5fd4c1]" />{content.email2}</a></li>}
            <li className="flex items-center gap-3"><MapPin size={16} className="text-[#5fd4c1]" />{content?.address}</li>
          </ul>
          <button onClick={() => openChat()} className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#0e8c7f] px-5 py-2.5 text-sm font-semibold text-white hover:bg-[#0b7569] transition-colors">
            <MessageSquareText size={16} /> {t("Live Chat")}
          </button>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-[1346px] flex-col items-center justify-between gap-2 px-6 py-6 text-[13px] text-white/50 md:flex-row lg:w-[86%] lg:px-0">
          <span>© {new Date().getFullYear()} {content?.brand}. {t("All rights reserved.")}</span>
          <span>{t("We only purchase sealed, unexpired supplies.")}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
